
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Rockwood_classification_of_acromioclavicular_joint_dislocation',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Rockwood_classification_of_acromioclavicular_joint_dislocation.vue